module.exports = __webpack_public_path__ + "img/petstairs17.76badd60.jpg";